import { Button } from 'edrolo-style-guide';
import { useState, useEffect } from 'react';
// TODO: re-enable correctness ui when we can calculate it correctly
import GrokSelfReflection from '../../../GrokSelfReflection';
import QuestionSolution from '../../../QuestionSolution';
import styles from './styles.scss';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import { FormGroup, FormControl } from 'react-bootstrap';
import InlineAlert from 'edrolo-style-guide/components/InlineAlert/InlineAlert';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import questionTypePropInterface from '../../questionTypePropInterface';

const isValid = (value) => {
  if (value === '-') {
    return true;
  }
  if (typeof value != 'string') {
    return false;
  }
  if (isNaN(value) || isNaN(parseFloat(value))) {
    return false;
  }
  return true;
};

export const NumberQuestion = ({
  question,
  response,
  onSubmit,
  onSubmitGrok,
  grokkingItemIsSaving,
  onSubmitTeacherAnswer,
}) => {
  const [answer, setAnswer] = useState([]);
  const [answerIsValid, setAnswerIsValid] = useState(true);

  useEffect(() => {
    if (!response) {
      // Addresses a bug where answer from previous, completed question remained
      // in state. This made it impossible to enter a new answer, because the
      // field IDs didn't match.
      setAnswer([]);
      return;
    }
    const fieldResponses = response.get('field_responses')?.toJS() || [];
    setAnswer([
      {
        fieldId: fieldResponses[0].field_id,
        submittedValue: fieldResponses[0].submitted_value,
      },
    ]);
  }, [response]);

  useEffect(() => {
    setAnswerIsValid(
      answer?.filter((a) => isValid(a?.submittedValue))?.length ===
        answer?.length
    );
  }, [answer, setAnswerIsValid]);

  // TODO: re-enable correctness ui when we can calulate it correctly
  // const isCorrect = response?.get('is_correct', false);
  const fields = question.get('fields').toJS();

  const answerIsValidForSubmission =
    answer?.filter((a) => a && isValid(a?.submittedValue))?.length ===
    fields?.length;

  function updateAnswer(value, id) {
    if (value.length && !isValid(value)) {
      return setAnswerIsValid(false);
    }

    let newAnswer = answer ? [...answer] : [];

    const existingAnswer = newAnswer.find((a) => a?.fieldId === id);

    if (!existingAnswer) {
      newAnswer.push({ fieldId: id, submittedValue: value });
    }

    if (existingAnswer && !value.length) {
      newAnswer = newAnswer.filter((a) => a.fieldId !== id);
    }

    if (existingAnswer && !!value.length) {
      newAnswer = newAnswer.filter((a) => a.fieldId !== id);
      newAnswer.push({
        fieldId: id,
        submittedValue: value,
      });
    }

    setAnswer(newAnswer);
  }
  return (
    <>
      <div
        className={styles.numberQuestion}
        data-test={`${response ? 'answer' : 'question'}-${
          EXAM_QUESTION_TYPES.NUMBER
        }`}
      >
        <div className={styles.question}>
          <FormGroup className={styles.formGroup}>
            {fields?.map((field) => {
              const { id, prefix, suffix } = field;
              const value =
                answer?.find((a) => a?.fieldId === id)?.submittedValue || '';

              return (
                <div key={id} className={styles.inputWrapper}>
                  {prefix && <span>{prefix}</span>}
                  <FormControl
                    componentClass="input"
                    onChange={(e) => updateAnswer(e.target.value, id)}
                    value={value}
                    disabled={!!response}
                  />
                  {suffix && <span>{suffix}</span>}
                </div>
              );
            })}
          </FormGroup>
          {/*
          TODO: re-enable correctness ui when we can calulate it correctly
          {!!response && (
            <span
              className={cx(styles.check, { [styles.incorrect]: !isCorrect })}
            />
          )} */}
        </div>
        {!answerIsValid && (
          <InlineAlert type="error">
            Only numbers can be entered here
          </InlineAlert>
        )}
      </div>
      {!response && (
        <Button
          onClick={() =>
            onSubmitTeacherAnswer
              ? onSubmitTeacherAnswer()
              : onSubmit({ fieldResponses: answer })
          }
          disabled={!answerIsValidForSubmission}
          data-test={`submit-${EXAM_QUESTION_TYPES.NUMBER}`}
        >
          {onSubmitTeacherAnswer ? 'View answer' : 'Save & continue'}
        </Button>
      )}
      {!!response && (
        <>
          <QuestionSolution
            headingText="Solution"
            questionId={question.get('id')}
            explanation={response.getIn(['solution', 'explanation'])}
            videoHash={response.getIn([
              'solution',
              'video',
              'wistia_hashed_id',
            ])}
            videoThumbnailUrl={WistiaUtils.getThumbnail(
              response.getIn(['solution', 'video'])
            )}
          />
          <GrokSelfReflection
            value={response.get('grokked')}
            onChange={onSubmitGrok}
            isSaving={grokkingItemIsSaving}
            className={styles.selfReflection}
          />
        </>
      )}
    </>
  );
};

NumberQuestion.propTypes = {
  ...questionTypePropInterface,
};
